"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KEYBOARD_CODES = void 0;
const KEYCODES = {
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  SEMICOLON: 186,
  DELETE: 46,
  BACKSPACE: 8,
  DOT: 190,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
var _default = exports.default = KEYCODES;
const KEYBOARD_CODES = exports.KEYBOARD_CODES = {
  TAB: 'Tab',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SEMICOLON: 'Semicolon',
  DELETE: 'Delete',
  BACKSPACE: 'Backspace',
  DOT: 'Period',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown'
};